const $input = $('input[name="address[zip]"], .autocomplete-address');

function getObjData(place, string) {
  return place.address_components.filter(item => item.types.indexOf(string) >= 0)
}

function setData($ele, data) {
  if (data.length) {
    $ele.val(data[0].long_name);
  }
}

function noResults($parent){
  const dataNoresults = $parent.data('no-results')
  $parent.find('.no-results').remove();
  $parent.append('<p class="no-results">' + dataNoresults + '</p>')
}

$('.show-autocomplete').on('click', function() {
  const $this = $(this);
  $this.toggleClass('clicked').parent().find('.autocomplete-address').toggle().focus();
})

$input.each(function() {
  const $this = $(this);
  const options = {
    types: ['geocode'],
    componentRestrictions: {country:'jp'}
  };

  $input.on('keydown', function(event) {
    if (event.keyCode === 13) {
        event.preventDefault(); 
    }
  })

  let autocomplete = new google.maps.places.Autocomplete($this[0], options);

  autocomplete.addListener('place_changed', function() {
    const place = autocomplete.getPlace();
    const $form = $this.closest('form');

    const $postCode = $form.find('input[name="address[zip]"]');
    const $prefecture = $form.find('input[name="address[province]"]');
    const $city = $form.find('input[name="address[city]"]');
    const $address1 = $form.find('input[name="address[address1]"]');

    const prefectureData = getObjData(place, 'administrative_area_level_1');
    const cityData = getObjData(place, 'locality');
    const postcodeData = getObjData(place, 'postal_code');
    const address1 = getObjData(place, 'sublocality');

    setData($postCode, postcodeData);
    setData($prefecture, prefectureData);
    setData($city, cityData);
    setData($address1, address1);

    setTimeout(function() {
      $this.closest('.form__controls').find('.no-results').remove();
    }, 100)
  })

  $this.on('keyup', function(event) {
    if (event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40) {
      return false;
    }
    const $parent = $this.closest('.form__controls');
    if ($('.pac-container:visible').length) {
      $parent.find('.no-results').remove();
    } else {
      noResults($parent);
    }
  })
})

setTimeout(function() {
  $('.js-stop-autofill').each(function(item) { $(this).attr('autocomplete', 'whatever') })
}, 1000)
